/**
 * Calcula a data mínima permitida para admissão com base no dia da semana e horário atuais
 * @returns {Date} data mínima para admissão
 */
export function getMinAdmissionDate() {
  // Captura a data e hora atual do navegador
  const now = new Date();

  // Obtém a hora e minutos atuais
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  // Determina se é depois do horário de corte (12:30)
  const isAfterCutoff =
    currentHour > 12 || (currentHour === 12 && currentMinutes >= 30);

  // Obtém o dia da semana (0=Domingo, 1=Segunda, ..., 6=Sábado)
  const dayOfWeek = now.getDay();

  // Cria uma nova data para não modificar a original
  const result = new Date(now);

  // Ajustar data baseado no dia da semana e horário
  switch (dayOfWeek) {
    case 0: // Domingo -> Quarta
      result.setDate(now.getDate() + 3);
      break;
    case 1: // Segunda
      if (isAfterCutoff) {
        // depois de 12h30 -> Quinta
        result.setDate(now.getDate() + 3);
      } else {
        // antes de 12h30 -> Quarta
        result.setDate(now.getDate() + 2);
      }
      break;
    case 2: // Terça
      if (isAfterCutoff) {
        // depois de 12h30 -> Sexta
        result.setDate(now.getDate() + 3);
      } else {
        // antes de 12h30 -> Quinta
        result.setDate(now.getDate() + 2);
      }
      break;
    case 3: // Quarta
      if (isAfterCutoff) {
        // depois de 12h30 -> Segunda próxima
        result.setDate(now.getDate() + 5);
      } else {
        // antes de 12h30 -> Sexta
        result.setDate(now.getDate() + 2);
      }
      break;
    case 4: // Quinta
      if (isAfterCutoff) {
        // depois de 12h30 -> Segunda próxima
        result.setDate(now.getDate() + 4);
      } else {
        // antes de 12h30 -> Segunda próxima
        result.setDate(now.getDate() + 4);
      }
      break;
    case 5: // Sexta
      if (isAfterCutoff) {
        // depois de 12h30 -> Quarta próxima
        result.setDate(now.getDate() + 5);
      } else {
        // antes de 12h30 -> Terça próxima
        result.setDate(now.getDate() + 4);
      }
      break;
    case 6: // Sábado -> Quarta próxima
      result.setDate(now.getDate() + 4);
      break;
    default:
      break;
  }

  // Adicionar informações para diagnóstico
  // eslint-disable-next-line no-underscore-dangle
  result._debug = {
    currentTime: `${currentHour}:${currentMinutes}`,
    isAfterCutoff,
    dayOfWeek,
  };

  return result;
}

// Função auxiliar para adicionar dias úteis
export function addBusinessDays(date, days) {
  if (typeof days !== 'number' || days < 0) return date;
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      added += 1;
    }
  }
  return result;
}
